export const ANALYTICS_GROUPS = {
  PROJECT: "project",
};

export const ANALYTICS_EVENTS = {
  TERMS_AND_CONDITIONS_VIEWED: "Terms And Conditions Viewed",
  CHANGE_PASSWORD: "Change Password",
  MEMBERSHIP_SWITCHED: "Membership Switched",
  ORGANIZATION_SEARCH: "Organization Search",
  ANALYTICS_FULLSCREEN_TOGGLED: "Analytics Fullscreen Toggled",
  ORGANIZATION_EDIT: "Organization Edit",
  TEAM_ROLE_EDIT: "Team Role Edit",
  TEAM_MEMBER_REMOVED: "Team Member Removed",
  INVITE_MEMBER: "Invite Member",
  WHATSAPP_TEST_TRIGGERED: "WhatsApp Test Triggered",
  WHATSAPP_CONNECT_TRIGGERED: "WhatsApp Connect Triggered",
  WHATSAPP_NUMBER_TOGGLED: "WhatsApp Number Toggled",
  CHATWOOT_LINK_OPENED: "Chatwoot Link Opened",
  GOOGLE_CALENDAR_CONNECT_TRIGGERED: "Google Calendar Connect Triggered",
  GOOGLE_CALENDAR_REVOKED: "Google Calendar Revoked",
  SCHEDULING_VISIBILITY_TOGGLED: "Scheduling Visibility Toggled",
  CALENDAR_VIEW_CHANGED: "Calendar View Changed",
  CALENDAR_TODAY_PRESSED: "Calendar Today Pressed",
  CALENDAR_CREATE_MENU_OPENED: "Calendar Create Menu Opened",
  CREATE_BUSY_SLOT: "Create Busy Slot",
  CALENDAR_EVENT_OPENED: "Calendar Event Opened",
  CALENDAR_PARTICIPANT_POPOVER_OPENED: "Calendar Participant Popover Opened",
  AVAILABILITY_ACTION: "Availability Action",
};
